import { combineReducers } from 'redux'
import { loadingReducer } from 'redux-foundry'
import { API_LISTAR_CONVERSOES_TEMPO } from 'store/modules/api/conversoesTempo.actions'

const lista = (state = [], { type, payload }) => (
  (type === API_LISTAR_CONVERSOES_TEMPO.success) ? payload : state
)

const isCarregandoLista = loadingReducer(false, API_LISTAR_CONVERSOES_TEMPO)

export default combineReducers({
  lista,
  isCarregandoLista,
})
